// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1oVcn","obliqueLineWrap":"membershipbadge_obliqueLineWrap__13roc","obliqueLine":"membershipbadge_obliqueLine__3bcm7"};